import React from 'react';

const Version = () => {
  return <p>아이피스 버전 : v 2.1.26</p>;
};

export default Version;